module.exports = __webpack_public_path__ + "img/earth.8fb92f1.png";